import styled from 'styled-components'

export const StyledHeader = styled.header`
  background-color: ${({ theme }) => theme.component.topbar.backgroundColor};
  border-bottom: ${({ theme }) => theme.component.topbar.borderBottom};
  height: ${({ theme }) => theme.component.topbar.height};
  color: ${({ theme }) => theme.component.topbar.color};
  position: relative;
  z-index: 100;
`

export const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.component.topbar.padding};
`

export const BrandSection = styled.div`
  display: flex;
  flex-direction: column;
`

export const AppTitle = styled.h1`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.heading.size.md};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  font-family: ${({ theme }) => theme.typography.heading.family};
  color: ${({ theme }) => theme.palette.text.default};
  line-height: ${({ theme }) => theme.typography.heading.lineHeight.short};
`

export const AppSubtitle = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body.size.sm};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  color: ${({ theme }) => theme.palette.text.support};
  opacity: 0.8;
`

export const UserSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[40]};
`

export const UserInfo = styled.div`
  text-align: right;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[10]};
`

export const UserName = styled.div`
  font-size: ${({ theme }) => theme.typography.body.size.sm};
  font-weight: ${({ theme }) => theme.typography.weight.medium};
  color: ${({ theme }) => theme.palette.text.default};
`

export const UserRole = styled.div`
  font-size: ${({ theme }) => theme.typography.body.size.xs};
  color: ${({ theme }) => theme.palette.text.support};
  opacity: 0.7;
`